
import {Session} from "../../h5_src/framework/Session";
// import navMenuItems from '../../layouts/components/vertical-nav-menu/navMenuItems.js';

let navMenuItems = [
    {items: []}
];


const DefaultMenuLayout = [{
    header: 'Yooz',
    icon: 'FileIcon',
    items: []
}];

export default {
    namespaced: true,
    state: {
        showingMenu: []
    },
    mutations: {
        _clear(state) {
            state.showingMenu = DefaultMenuLayout;
        },
        _sync(state, menuItems) {

            // console.log(['_sync-menu-items-2', menuItems]);

            navMenuItems[0].items = menuItems;

        },
        _update(state) {

            // let payload = Session.getSessionVariables();
            // console.log(['update', payload]);

            let _menu = [{
                header: DefaultMenuLayout[0].header,
                icon: DefaultMenuLayout[0].icon,
                items: []
            }];

            // console.log(['menus', JSON.stringify(navMenuItems[0].items)]);

            let idx, ref, regex, is_match, jdx, calc_unique, canSee;

            for (idx = 0; idx < navMenuItems[0].items.length; idx++) {

                ref = navMenuItems[0].items[idx];

                // 其他菜单直接顺序添加
                _menu[0].items.push(ref);

            }

            state.showingMenu = _menu;

        }
    },
    getters: {
        showing_menu: state => {
            return  state.showingMenu;
        },
        userId: state => {
            return state.userId;
        },
    },
    actions: {
        clear({commit}) {
            commit('_clear');
        },
        syncMenuItems({commit}, items) {
            commit('_sync', items);
        },
        update({commit}) {
            commit('_update');
        }
    }

};
